<i18n>
{
	"en": {
		"noItemsText": "No assignments to show."
	},
	"fi": {
		"noItemsText": "Tehtäviä ei löytynyt."
	}
}
</i18n>

<template>
	<div>
		<router-view :key="$route.fullPath" />

		<template v-if="$route.name == 'assignments'">
			<v-container class="container--narrow">
				<FilterableList
					v-if="items.length"
					:items="items"
					@itemClick="itemClick"
					:enable-search="false"
				/>
			</v-container>
		</template>
	</div>
</template>

<style scoped>
.benefits >>> h2 {
	margin-bottom: 1rem;
}
.benefits >>> ul {
	margin-bottom: 1.5rem;
}
.benefits >>> ul li + li {
	margin-top:  0.5rem;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Assignments',

	computed: {
		...mapState({
			items: state => state.user.assignment,
		}),
	},

	mounted () {
		this.$api.Me.doRequest()
	},

	methods: {
		itemClick (item) {
			this.$router.push({
				name: 'assignment',
				params: {
					assignmentName: item.name,
				},
			})
		},
	},
}
</script>
